import qs from 'query-string';
import { ApiError, FetchStatus, Params, UrlParams } from 'types';

export const paramsSerializer = (params: Params): string =>
  qs.stringify(params, { arrayFormat: 'comma' });

export const apiErrorsMesages = {
  networkError: 'Network Error',
  incorrectUsernameOrPassword: 'Incorrect username or password.',
};

export function UserException({ message }: { message: string }): void {
  this.message = message;
}

export const injectUrlParams = (url: string, urlParams: UrlParams = {}): string => {
  let filledUrl = url;

  Object.entries(urlParams).forEach(([key, value]) => {
    const pattern = `:${key}`;
    if (filledUrl.includes(pattern) && value !== undefined) {
      filledUrl = filledUrl.replace(pattern, value.toString());
    }
  });

  return filledUrl;
};

export const fillPath = ({
  path,
  params,
  urlParams,
}: {
  path: string;
  params?: Params;
  urlParams?: UrlParams;
}): string => {
  const flattenPath = injectUrlParams(path, urlParams);
  return params ? `${flattenPath}?${paramsSerializer(params)}` : flattenPath;
};

export const mergeApiStatus = (...args: Array<FetchStatus>): FetchStatus => {
  const out = { ...args[0] };
  const keys = Object.keys(out) as Array<keyof FetchStatus>;

  keys.forEach((key) => {
    args.slice(1).forEach((arg) => {
      if (arg[key]) {
        out[key] = arg[key] as (ApiError | null) & boolean;
      }
    });
  });

  return out;
};
